var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoximage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard-svgrepo-com",
    d: "M3,17.722H14.778V3H3ZM3,29.5H14.778V20.667H3Zm14.722,0H29.5V14.778H17.722Zm0-26.5v8.833H29.5V3Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoximage);
export default __webpack_public_path__ + "static/media/boximage.e7677dc5ab772ed651871084b7c02478.svg";
export { ForwardRef as ReactComponent };